export default __webpack_public_path__ + "static/media/cfa-cooperativa.094e2ad4.png";